module.exports = require("cytoscape-navigator");